import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import LocalisedTime from 'components/common/LocalisedTime'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'

export const MinimizedAvailanility = () => {
  const availabilityId = InputProvider.useAvailabilityId('optional')
  return (
    <div className="text-end">
      {availabilityId ? <LocalisedTime date={formatAvailabilityId(availabilityId)} /> : null}
    </div>
  )
}
